<template>
  <section>
    <div class="box w100">
      <div class="box-title">
        <div class="flex between middle">
          <div class="flex-1">
            <b>Conversa</b>
          </div>
          <div class="flex-1 flex end">
            <div class="button primary" @click="showModalCreate=true">Criar Conversão</div>
          </div>

        </div>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div v-if="detail.conv.name" class="margin-top-s">
            Nome: {{ detail.conv.name | protect  }}
          </div>
          <div v-else  class="margin-top-s"> Nome: - </div>
          <div v-if="detail.conv.phone" class="margin-top-s">
            Telefone: {{ detail.conv.phone | protect  }}
          </div>
          <div v-else  class="margin-top-s"> Telefone: - </div>
          <div class="margin-top-s">
            é Comprador? <span v-if="detail.sales && detail.sales.length > 0"> Sim</span> <span else> Não</span>
          </div>
        </div>
      </div>
      <div v-else>
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Compras</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.sales && detail.sales.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Plataforma</b>
            </div>
            <div class="flex-1">
              <b>Status</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.sales" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ s.order_id  | protect  }}
            </div>
            <div class="flex-1">
              {{ s.platform }}
            </div>
            <div class="flex-1">
              {{ s.status }}
            </div>
            <div class="flex-1">
              {{ s.created_at | date }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos compras...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Produtos</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div v-if="detail.products && detail.products.length > 0" class="flex column">
          <div class="flex w100">
            <div class="flex-2">
              <b>Nome</b>
            </div>
          </div>
          <div v-for="(p, key) in detail.products" :key="key" class="flex w100 margin-top-s">
            <div class="flex-2">
              {{ p  | protect  }}
            </div>
          </div>
        </div>
        <div v-else> Não encontramos produtos...</div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>

    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Páginas Visitadas</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div class="flex w100">
            <div class="flex-1">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Data</b>
            </div>
            <div class="flex-1">
              <b>Tipo de Visita</b>
            </div>
            <div class="flex-2">
              <b>Url</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.trackers" :key="key" class="flex w100 column jorney-style">
            <div class="flex w100 margin-top-s middle">
              <div class="flex-1">
                {{ s.id | number  }}
              </div>
              <div v-if="s.track_type" class="flex-1">
                <b>{{ decodePv(s.track_type) }}</b>
              </div>
              <div class="flex-1">
                {{ s.created_at | date }}
              </div>
              <div v-if="!s.url.includes('no-page-tracker')" class="flex-2">
                <b>{{ s.url  | protect  }}</b>
              </div>
              <div v-else class="flex-2"> - </div>
              
            </div>
            <div class="flex w100 margin-top-s column">
              <div class="flex-1 flex column">
                <span class="tag" v-if="checkParam(s.utm_campaign)">utm_campaign: {{ s.utm_campaign | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_medium)">utm_medium: {{ s.utm_medium | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_source)">utm_source: {{ s.utm_source | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_content)">utm_content: {{ s.utm_content | protect  }}</span>
                <span class="tag" v-if="checkParam(s.utm_term)">utm_term: {{ s.utm_term | protect  }}</span>
                <span class="tag" v-if="checkParam(s.src)">src: {{ s.src | protect  }}</span>
                <span class="tag" v-if="checkParam(s.sck)">sck: {{ s.sck | protect  }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </div>
    <div class="box w100 margin-top-s">
      <div class="box-title">
        <b>Mensagens</b>
      </div>
      <div v-if="!loading" class="box-content">
        <div class="flex column">
          <div class="flex w100">
            <div class="flex-1">
              <b>Data</b>
            </div>
            <div v-if="false" class="flex-1">
              <b>Id</b>
            </div>
            <div class="flex-1">
              <b>Nome</b>
            </div>
            <div class="flex-2">
              <b>Mensagem</b>
            </div>
          </div>
          <div v-for="(s, key) in detail.mensagens" :key="key" class="flex w100 margin-top-s line-style">
            <div class="flex-1">
              {{ s.created_at | date }}
            </div>
            <div v-if="false" class="flex-1">
              {{ s.id | number }}
            </div>
            <div class="flex-1">
              <span v-if="s.name">{{ s.name | protect  }}</span>
              <span v-else> - </span>
            </div>
            <div class="flex-2 content-msg">
              {{ s.content | protect  }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <modal
        title="Ativar Conversão"
        :show="showModalCreate"
        @close="showModalCreate = false"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form autocomplete="off" class="w100">
                <div class="flex w100 column margin-top-s">
                    <label>Nome da Conversão:</label>
                    <select class="input" v-model="newConver.conversion">
                      <option value="">Seleciona</option>
                      <option
                        v-for="(f, index) in conversions"
                        :key="index"
                        :value="f"
                        :selected="f.id === newConver.conversion.id"
                      >
                        {{ f.name }} ({{ f.event_value | money }}) ({{ f.platform }}) 
                      </option>
                    </select>
                  </div>

            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="saveConversion()">Criar</div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </section>
</template>

<script>
import Modal from "@/components/modal/Modal";


import { 
  getConversation,
  createConversionMsg
} from "@/services/jorney-detail";

import {
  getConversionWhats,
} from "@/services/conversionWhats";


export default {
  name: "msg-detail",
  components: {
    Modal
  },
  props: ['cov_id'],
  data() {
    return {
      loading: false,
      showModalCreate: false,
      newConver: {
        conversion: '',
      },
      conversions: [],
      detail: {
        conv: {},
        sales: [],
        mensagens: [],
        products: [],
        trackers: [],
      },
    };
  },
  mounted() {
    this.getConv()
    this.getConversionWhats()
  },
  methods: {
    saveConversion() {
      let params = {
        id: this.newConver.conversion.id,
        rule_name: this.newConver.conversion.rule_name,
        name: this.newConver.conversion.name,
      }

      createConversionMsg(this.detail.conversation.id, params)
        .then((result) => {
          this.detail.mensagens.push(result)
          this.$toast.success({
            title:'Sucesso',
            message:'Conversão criada com sucesso'
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalCreate = false
        })

    },
    getConversionWhats() {
      this.loading = true
      getConversionWhats()
        .then((result) => {
          this.conversions = result.conversion_whats
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar conversões personalizadas",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkParam(p) {
      if (!p) {
        return false
      }

      if (p && (!p.includes("LUCREIHOJE") && !p.includes("UNICOTRACKER"))) {
        return true
      }
    },
    decodePv(pv) {
      var _m = {
        "LAST_PV": "Última Vísita antes da Conversa",
        "FIRST_PV": "Primeira Vísita",
        "JORNEY_BEFORE": "Jornada Pré-Conversa",
        "JORNEY_AFTER": "Jornada Pos-Conversa",
      }

      return _m[pv] || pv
    },
    getConv() {
      this.loading = true
      getConversation(this.cov_id)
      .then((result) => {
        this.detail = result
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
            return;
          }
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      })
      .finally(() => {
        this.loading = false
      })
    }

  }


};
</script>

<style lang="scss" scoped>
.grid-flex .box + .box, .flex .box + .box {
  margin-left: 0px;
}

.content-msg {
  padding-left: 8px;
  padding-right: 8px;
}

.line-style {
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  padding: 4px;
}
</style>
